import React from "react"
import { withRouter, Redirect } from "react-router-dom"
import { URI_LIST } from "constructs"

const Index = () => <Redirect to={URI_LIST.admin.news.new} />

export default withRouter(Index)